module.exports = __webpack_public_path__ + "static/media/FMFA.68032878.jpg";